import { Button, Modal } from 'antd';
import React, { FC } from 'react'

interface IProps {
    visualizar: boolean;
    setVisualizar: any;
    onAceptar: any;
    titlle: string;
    description: string;
    subdescription?: string;
}

const ModalSuccess: FC<IProps> = ({ visualizar, setVisualizar, onAceptar, titlle, description, subdescription }) => {
    return (
        <Modal
            // title=""
            visible={visualizar}
            onCancel={onAceptar}
            maskStyle={{
                background: "rgba(75, 100, 59, 0.62)",
            }}
            width={662}
            footer={[
                <div key="B_Aceptar_ModalSuccess" className="text-center">
                    <Button onClick={onAceptar} className="button-azul-radius" style={{ marginTop: 0, marginBottom: 0 }} htmlType="submit">
                        Aceptar
                    </Button>
                </div>
            ]}
            cancelButtonProps={{ style: { display: "none" } }}
        >
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 font-size-24px font-color-29740B font-family-Montserrat-SemiBold justify-content-center">
                        {titlle}
                    </div>
                    <div className="text-center col-12 font-family-Montserrat-Regular font-size-14px justify-content-center font-color-000000 mt-2">
                        {description}
                    </div>
                    <div className="text-center col-12 font-family-Montserrat-bold font-size-14px justify-content-center mt-1 font-color-000000">
                        {subdescription}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ModalSuccess